import React, {useEffect, useRef} from 'react';
import {observer} from "mobx-react-lite";
import Select from 'react-select';
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import {useTranslation} from "react-i18next";
import {useLocation} from 'react-router-dom'

const CustomSelect = ({options, game, setGame}) => {
    const {t} = useTranslation()
    const {search} = useLocation()
    const location = useLocation()
    const useSelect = useRef(null);
    let arr = [];

    if (Object.keys(options)[0] === 'all') {
        Object.values(options).map(value => arr.push({...value, label: `${t(value.label.split(':')[0])}: ${t(value.label.split(':')[1])}`}));
    } else {
        Object.values(options).slice(0).reverse().map(value => arr.push({...value, label: `${t(value.label.split(':')[0])}: ${t(value.label.split(':')[1])}`}));
    }

    const renderScrollbar = props => {
        return (
            <div className="chosen-select__scrollbar">
                <OverlayScrollbarsComponent>{props.children}</OverlayScrollbarsComponent>
            </div>
        );
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(search);
        if (useSelect) {
            if (Array.from(searchParams).length > 0) {
                searchParams.forEach((value, key) => {
                    if (key === game.label.split(':')[0].toLowerCase()) {
                        useSelect.current.selectOption({...options[value === '' ? 'all' : value], label: `${t(options[value === '' ? 'all' : value].label.split(':')[0])}: ${t(options[value === '' ? 'all' : value].label.split(':')[1])}`});
                    }
                })
            } else {
                useSelect.current.selectOption({...options.all, label: `${t(options.all.label.split(':')[0])}: ${t(options.all.label.split(':')[1])}`});
            }
        }
    }, [search, location, useSelect, t]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (useSelect ) {
            document.querySelectorAll('input[inputmode="none"]').forEach(input => input.setAttribute('type', 'radio'))
        }
    }, [useSelect])

    return (
        <Select
            ref={useSelect}
            isSearchable={false}
            inputProps={{readOnly:true}}
            defaultValue={{...game, label: `${t(game.label.split(':')[0])}: ${t(game.label.split(':')[1])}`}}
            onChange={setGame}
            className={`chosen-select`}
            classNamePrefix="chosen-select"
            options={arr}
            components={{
                MenuList: renderScrollbar
            }}
        />
    )
};

export default observer(CustomSelect);